import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetOnboardingProgressQuery,
  GetOnboardingProgressQueryVariables,
} from "./OnboardingProgress.generated";

const ONBOARDING_PROGRESS_QUERY: TypedDocumentNode<
  GetOnboardingProgressQuery,
  GetOnboardingProgressQueryVariables
> = gql`
  query GetOnboardingProgress {
    onboardingProgress {
      onboardingMilestones
      distinctNoteCreationDays
      hasApprovedNote
      hasExportedNote
      hasCreatedTemplate
    }
  }
`;

export default ONBOARDING_PROGRESS_QUERY;
